import ReactDOM from 'react-dom/client';
import { RootComponent } from './root.component';

ReactDOM.createRoot(document.getElementById('root')!).render(<RootComponent />);
